export default __webpack_public_path__ + "static/image-e3177956b047d1f9ee98fb664c0e6092.png";